import React from 'react'
import { ThemeProvider } from 'styled-components'
import { Row, Col, Grid } from 'react-styled-flexboxgrid'
import PropTypes from 'prop-types'

import * as ArrayTools from '~/utilities/array'
import Item from './Item'
import Center from '~/components/basic/Center'

const FlexBoxGridTheme = {
  flexboxgrid: {
    gridSize: 12,
    gutterWidth: '1',
    outerMargin: '0',
    mediaQuery: 'only screen',
    container: {
      sm: 46,
      md: 61,
      lg: 76
    },
    breakpoints: {
      xs: 0,
      sm: 48,
      md: 64,
      lg: 75
    }
  }
}

const ITEM_COL_SIZE = {
  lg: 4,
  md: 4,
  sm: 4,
  xs: 12
}

const List = ({ pointsArr, margin }) => {
  const chunks = ArrayTools.chunk(pointsArr, 3)
  return (
    <ThemeProvider theme={FlexBoxGridTheme}>
      <Grid
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}
      >
        {chunks.map(chunk => {
          return (
            <Row key={chunk[0].title}>
              {chunk.map(item => {
                return (
                  <Col key={item.title} {...ITEM_COL_SIZE}>
                    <Center>
                      <Item {...item} margin={margin} />
                    </Center>
                  </Col>
                )
              })}
            </Row>
          )
        })}
      </Grid>
    </ThemeProvider>
  )
}

List.defaultProps = {
  pointsArr: []
}

List.propTypes = {
  pointsArr: PropTypes.arrayOf(PropTypes.object)
}

export default List
